import React from 'react';
import { Route, Routes } from 'react-router-dom';
import UserList from './UserList';
import UserForm from './UserForm';

const UserRoutes = () => {
  return (
    <Routes>
      <Route index element={<UserList />} />
      <Route path="new" element={<UserForm />} />
      <Route path="edit/:id" element={<UserForm />} />
    </Routes>
  );
};

export default UserRoutes; 